import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  headingStyle: {
    fontFamily: 'Arial, sans-serif',
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
    color: '#303a44',
    lineHeight: 1.33,
    margin: '10.5px 0'
  }
})

const Heading5 = ({
  classes: { headingStyle },
  className,
  component,
  children,
  ...otherProps
}) => {
  const headingClass = classNames(headingStyle, className)
  return (
    <Typography
      component={component || 'h5'}
      className={headingClass}
      {...otherProps}
    >
      {children}
    </Typography>
  )
}

Heading5.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node
}

export default withStyles(styles)(Heading5)



// WEBPACK FOOTER //
// ./src/styleguide/Heading5.js